export const Routes: Record<string, string> = {
  home: '/home',
  public: '/public',
};
